// extracted by mini-css-extract-plugin
export var checkbox = "_38-0";
export var circle = "_38-3";
export var horizontalContainer = "_38-7";
export var sm = "_38-5";
export var switch0 = "_38-2";
export var switchDisabled = "_38-8";
export var switchEnabled = "_38-1";
export var textSwitchContainer = "_38-9";
export var textSwitchOption = "_38-a";
export var textSwitchOptionSelected = "_38-b";
export var verticalContainer = "_38-6";
export var xs = "_38-4";